var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 25.895V6h22.842C26.562 6.295 30 7.754 30 11.232c0 3.477-1.867 4.494-2.8 4.568.933.368 2.8 1.65 2.8 3.832v6.263h-8.105v-4.716c-.099-.689-.678-2.064-2.21-2.064h-9.58v6.779H2zm8.4-12.232v-1.842h10.61c.295.124.885.517.885 1.106 0 .59-.59.983-.885 1.106l-10.61-.369z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRari);
export default __webpack_public_path__ + "static/media/RARI.3c2412529eb8770c1f5570cf186f3ff5.svg";
export { ForwardRef as ReactComponent };